<template>
<div class="text-center card mb-4" v-on:click="$emit('click')" style="cursor: pointer">
	<div class="card-body">
		<!--
		<i class="fa fa-gift fa-5x text-primary mb-2"></i>
		<h3 style="font-weight: bold;" class="mb-0">
			Share {{ $store.appName }} and get paid $500
		</h3>
		<h4>Earn $500 for every company that signs up using your link</h4>
	-->
		<!--
		<div class="row">
			<div class="col-md-6 text-left">
				<div class="d-flex flex-column justify-content-between" style="height: 100%">
					<div class="mt-4">
						<h3 class="">Get Paid $500</h3>
						<p class="banner-blurb">Earn $500 for every company that signs up using your link</p>
					</div>
					<div class="mb-4">
						<button v-if="hasButton" class="btn btn-primary mt-4" v-on:click="$emit('click')">
							Get Started
						</button>
					</div>
				</div>
			</div>
			<div class="col-md-6">
				<img src="/resources/referral_icon.png" class="banner-icon">
			</div>
		</div>
		-->
		<img :src="$store.apiRoot + 'resources/referral_banner_01.png?c='+rand" class="full-banner-image">
	</div>
</div>
</template>
<script type="text/javascript">
export default {
	name: "ReferralLinkBanner",
	props: [
		"hasButton"
	],
	computed: {
		rand() {
			return Math.random()
		}
	}
}
</script>

<style scoped>
h3, h4 {
	font-family: 'Raleway', sans-serif;
	font-weight: 900;
}

.banner-blurb {
	font-size: 14pt;
}

.banner-icon {
	max-height: 300px;
}

.card {
	overflow: hidden;
}

.card-body {
	padding: 0;
}


@media (max-width: 500px) {
	

	h3 {
		font-size: 14pt;
	}	

	h4 {
		font-size: 12pt;
	}
}
</style>